import React, { Component } from 'react';

class IconBlock28 extends Component {
    render() {
        let cssClass = 'u-icon-v2 u-icon-size--3xl g-brd-7 g-brd-gray-light-v4 g-color-primary g-rounded-50x g-mb-25';
        let cssImg = 'icon-block-image-75';
        if (this.props.version === 1) {
            cssClass = 'g-bg-gray-light-v5 g-brd-7 g-brd-gray-light-v4 g-color-primary g-mb-25 g-rounded-50x u-icon-size--3xl u-icon-v2'
        } else if(this.props.version === 2) {
            cssImg = 'icon-block-image-100';
            cssClass = 'border-0 g-mb-25 g-rounded-50x u-icon-size--3xl u-icon-v2'
        }

        const blocks = this.props.content.map((block) =>
            <div key={block.id} className="col-md-4 g-mb-30">
                <div className="text-center">
                    <span className={cssClass}>
                        <img className={cssImg} src={block.img} alt={block.title}></img>
                    </span>
                    <h3 className="h5 g-color-black mb-25">{block.title}</h3>
                    <p className="g-color-gray-dark-v4 g-mb-0">{block.description}</p>
                </div>
            </div>

        );

        return (
            <div className="row g-mt-30">
                { blocks }
            </div>
        );
    }
}

export default IconBlock28;


// WEBPACK FOOTER //
// ./src/subcomponents/IconBlock28.js